import React from 'react';
import SettingsContainer from './settings-container';

const ProvidedSettings = () => (
  <SettingsContainer />
);

export default ProvidedSettings;
